import type { BaseComponent } from '@libs/ui/ds/lib/internals'
import type { Screen } from '@libs/ui/ds/lib/theme'
import { useScreensMediaQuery } from '@libs/ui/ds/lib/theme'
import { cva } from 'class-variance-authority'
import type { FC, HTMLAttributes, PropsWithChildren } from 'react'
import React from 'react'

import { useTopNavbarContext } from '../../TopNavbar.context'

const topNavbarMiddleCVA = cva(['flex h-full grow items-center gap-2'])

type Props = BaseComponent & PropsWithChildren & HTMLAttributes<HTMLDivElement>

export const TopNavbarMiddle: FC<Props> = ({
  children,
  className,
  ...other
}) => {
  const ctx = useTopNavbarContext()
  const match = useScreensMediaQuery({
    thresholdType: 'max',
    screenList: [ctx?.showDropdownBelowBreakpoint as Screen]
  })

  if (match) {
    return null
  }

  return (
    <div className={topNavbarMiddleCVA({ className })} {...other}>
      {children}
    </div>
  )
}
